import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*
 * Created on Wed Jul 18 2018
 */


import { GenericTransportLayer } from '../GenericTransportLayer';
import { GlobalSettingsConverter, jsonConversions } from '@logio/common-be-fe';
import { CONSTANTS } from '../../../constants';
import { Inject } from '@logio/typescript-ioc';
import logger from '../../logger';
import api from '../../api';
/**
 * @author BPo
 */

export var GlobalSettingsLayer =
/*#__PURE__*/
function (_GenericTransportLaye) {
  _inherits(GlobalSettingsLayer, _GenericTransportLaye);

  function GlobalSettingsLayer() {
    _classCallCheck(this, GlobalSettingsLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(GlobalSettingsLayer).call(this, CONSTANTS.API.ENDPOINTS.GLOBAL_SETTINGS));
  }

  _createClass(GlobalSettingsLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
  }, {
    key: "update",
    value: function update(item) {
      var _this = this;

      var updatePromise = api("".concat(this.baseUri, "/").concat(item.id)).put(this.getConverter().toDocument(item, jsonConversions), {
        responseType: 'json'
      }).then(function (response) {
        return _this.getConverter().toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return updatePromise;
    }
  }]);

  return GlobalSettingsLayer;
}(GenericTransportLayer);

__decorate([Inject, __metadata("design:type", GlobalSettingsConverter)], GlobalSettingsLayer.prototype, "converter", void 0);